/* eslint-disable global-require */
export default {
  question: require('./img/question.png'),
  avatar: require('./img/avatar.png'),
};
